import React from "react"
import { SvgIcon, SvgIconProps } from "@mui/material"

const fullScreenSvg = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 11V6H13V5H19V11H18ZM6 13V18H11V19H5V13H6Z" fill="currentColor"/>
    </svg>
)

const FullScreenIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {fullScreenSvg}
    </SvgIcon>
)

export default FullScreenIcon